export default __webpack_public_path__ + "static/media/CORPe-mobi.70ec1cc9.png";